import { useQuery } from '@tanstack/react-query';
import {
  getGetMilestoneIdProjectQueryKey,
  getMilestoneIdProject,
} from '../api/milestone-api/milestone-api';
import { MilestoneDto } from '../api/model';

export const useProjectMilestones = (projectId?: number) => {
  return useQuery({
    queryKey: projectId ? getGetMilestoneIdProjectQueryKey(projectId) : ['milestones', 'empty'],
    queryFn: async ({ signal }) => {
      if (!projectId) return [] as MilestoneDto[];
      return await getMilestoneIdProject(projectId, signal);
    },
    enabled: !!projectId,
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
};
